import React,{useState, useEffect} from 'react';
import style from './assessmentNotes.module.scss';
import { Button, Form, TextArea } from '../../primary';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router';
import { CUSTOMER_UPDATE_SUCCESS, ERROR_STATUS, SAVE_BTN, SUCCESS_STATUS, UPDATE_FAILURE } from '../../../constants';
import { fullMonthFormatDate, signedLockedAccess } from '../../../utils';
import {allowEnterData} from '../../../utils/patientsHelper';
import Loader from '../../../static/images/spinner.svg';
import { ZoomPhoto } from './Photos';
import { useDispatch, useSelector } from 'react-redux';
import warning from '../../../static/images/icon-check-danger.png';
import { Confirmation } from '../../secondary';
import { deleteAssessmentsNoteAsync, setDeleteAssessmentNoteState } from '../../../app/patientSlice';
import constants from '../../../constants/constants.json';

export const AssessmentNotes = ({ notes, postNotes, detailAssessment, hideIt }) => {
  const dispatch = useDispatch();
  const { patientId, assessmentId } = useParams();
  const { register, handleSubmit, reset } = useForm();
  const { measurementData } = useSelector((state) => state.patient.newWoundMeasurements) || { loading: false, measurementData: null };
  const deleteAssessmentNoteLoading = useSelector((state) => state.patient.deleteAssessmentNoteLoading);
  const deleteAssessmentNoteState = useSelector((state) => state.patient.deleteAssessmentNoteState);

  const [woundImageLoading, setWoundImageLoading] = useState(true);
  const [deleteConfirmationModal, setDeleteConfirmationModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  useEffect(() => {
      if(deleteAssessmentNoteState === SUCCESS_STATUS || deleteAssessmentNoteState === ERROR_STATUS) {
        setTimeout(() => {
          dispatch(setDeleteAssessmentNoteState(null));
        }, 5000);
      }
    }, [dispatch, deleteAssessmentNoteState]);

  const clearField = () => {
    reset();
  }
  const doSubmit = (data) => {
    if (data?.notes.trim() !== '') {
      const payload = {
        "assessmentId": assessmentId,
        "patientId": patientId,
        "notes": data.notes.trim()
      }
      postNotes(payload);
    }
    reset();
  }
  const allowEnter = (e) => {
    allowEnterData(e)
    // if (e.key === 'Enter') {
    //   e.stopPropagation();
    // }
  }

const [tinyDelay, setTinyDelay] = useState(false)

useEffect(() => {
  setTimeout(() => {
    setTinyDelay(true)
  }, 2500)
}, [])

const handleDeleteNote = (e) => {
  e?.preventDefault();
  dispatch(deleteAssessmentsNoteAsync(patientId, assessmentId, deleteId, setDeleteConfirmationModal));
  setDeleteId(null);
}

const handleDeleteAssessmentNote = (id) => {
  setDeleteConfirmationModal(true);
  setDeleteId(id);
}
  
  return <div>
    {deleteAssessmentNoteState === SUCCESS_STATUS && <div className={`alert alert-success d-inline-block`}>{CUSTOMER_UPDATE_SUCCESS}</div>}
    {deleteAssessmentNoteState === ERROR_STATUS && <div className={`alert alert-danger d-inline-block`}>{UPDATE_FAILURE}</div>}
      
{!tinyDelay ?<div className={`${'loader'} col-12`}>
				<img src={Loader} alt="loading" />
			  </div>:
        <>
    <div className="row d-flex d-flex row no-gutters">

      <div className={`col-4`} style={{overflow : 'hidden'}}>
        <div  className={`${style.patient_wound}`}>
          <ZoomPhoto
              image={measurementData?.assessedImageSASURL || measurementData?.intialImageSASURL || detailAssessment?.picture}
              loading={woundImageLoading}
              setLoading={setWoundImageLoading}
              showBottomBtn={false}
              classes={{
                outerClass: undefined,
                innerClass: "position-relative w-100",
                shimmerClass: style.image_skleton
              }}
              showTopBtn={detailAssessment?.isWoundWithoutPhoto === 0}
          />
        </div>
      </div>

      <div className={`col-8 w-100`}>
        <div className={`${style.notes_conatiner} w-100`}>
          {hideIt && signedLockedAccess(detailAssessment?.assessmentStage)? <div>
            <div className="pt-2 pb-2"><span className={style.notes_title}>Notes:</span> <span className={style.notes_sub_title}>(Optional)</span></div>
            <Form  onSubmit={handleSubmit(doSubmit)}>
              <div>
                <TextArea
                  classes={{ inputClassName: `${style.textarea_box} w-100 mb-2` }}
                  rows={3}
                  id={"notesField"}
                  name={"notes"}
                  placeholder={'Add notes here'}
                  validator={register}
                  onKeyPress={(e) => allowEnter(e)}
                />
              </div>
              <div className="d-flex justify-content-end w-100">
                <Button
                  type={"submit"}
                  value={SAVE_BTN}
                  id={"updateNotes"}
                  classes={{ className: `btn p-1 ${style.btn_primary}` }}
                />
                <Button
                  type={"button"}
                  value={'Clear'}
                  id={"updateCancel"}
                  classes={{ className: `btn p-1 ${style.btn_scondary}` }}
                  onClick={() => clearField()}
                />
              </div>
            </Form>
          </div>:'This wound assessment is signed and locked, cannot be updated.'}
          {notes&&Array.isArray(notes)&&notes?.length !== 0 && <div className={style.notes_container}>
            {notes&&Array.isArray(notes) && notes.map((data, index) => {
              return (
                <div className={style.entered_notes} key={index}>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className={style.post_details}>
                      <span className={style.creater_name}>{data.createdBy}</span> | <span>{fullMonthFormatDate(data.createdDate)}</span> |{" "}
                      <span>{data.createdByRole}</span>
                    </div>
                    <button
                      className={style.delete_icon}
                      type="button"
                      onClick={() => handleDeleteAssessmentNote(data?.id)}
                      disabled={!signedLockedAccess(detailAssessment?.assessmentStage)}
                    >
                      <i className={`fa fa-trash fa-lg`}></i>
                    </button>
                  </div>
                  <div className={style.notes_text}>{data?.notes === "" ? "Unknown" : data?.notes?.split("\n").map((str) => <div>{str}</div>)}</div>
                </div>
              ); 
            })}
          </div>}
        </div>
      </div>

    </div></>}
    {deleteConfirmationModal && (
        <Confirmation onClose={() => setDeleteConfirmationModal(false)} title={" "}>
          <div className="text-center pr-5 pl-5">
            <p>
              {deleteAssessmentNoteLoading ? (
                <div className="loader p-0">
                  <img src={Loader} alt="loading" />
                </div>
              ) : (
                <img src={warning} alt="warnning-icon" />
              )}
            </p>
            <p className="pb-3">{constants.deleteConfirmation}</p>
            <div className="mb-2">
              <Button value="Yes" classes={{ className: `btn mr-2 pb-2 pt-2 mr-3 ${style.btn_primary}` }} onClick={handleDeleteNote} />
              <Button
                value="No"
                classes={{ className: `btn ml-2 pb-2 pt-2 ${style.btn_scondary}` }}
                onClick={() => setDeleteConfirmationModal(false)}
              />
            </div>
          </div>
        </Confirmation>
      )}
  </div>
}
